import type { DynamoDBResourceBlock } from '@root/@types/database';

export const isSummaryBlock = (block?: Pick<DynamoDBResourceBlock, 'sk'>) => block?.sk?.startsWith('summary_blocks#');
